import { buildAlignedTotalsRow, getColumnIndex } from '@components/shared/Table/helpers/buildAlignedTotalsRow'

import type { ColumnDefProps } from '@components/shared/Table/types'

export interface CollaboratorsTotalsProps {
  totalRecords: number
  totalSalaries: number
  totalBenefits: number
  totalCharges: number
  grandTotal: number
}

/** Linha de totais da Gestão de Colaboradores: cada total fica sob a sua coluna de valor. */
export const parseCollaboratorsTotalsRow = (
  columns: ColumnDefProps[],
  totals: CollaboratorsTotalsProps | undefined
): ColumnDefProps[][] => {
  if (!columns.length || !totals) return []

  const totalsRow = buildAlignedTotalsRow({
    columns,
    label: `Total de registros: ${totals.totalRecords}`,
    labelSpan: getColumnIndex(columns, 'salaries'),
    values: {
      salaries: { label: 'Total Salários com Adicionais', value: totals.totalSalaries, currency: true },
      benefits: { label: 'Total Benefícios', value: totals.totalBenefits, currency: true },
      charges: { label: 'Total Encargos', value: totals.totalCharges, currency: true },
      grandTotal: { label: 'Total Geral', value: totals.grandTotal, currency: true }
    }
  })

  return totalsRow.length ? [totalsRow] : []
}
